import { render, staticRenderFns } from "./CardValor.vue?vue&type=template&id=c532729e&"
import script from "./CardValor.vue?vue&type=script&lang=js&"
export * from "./CardValor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports